import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { PlDatepickerComponent } from '@app/components/pl-datepicker/pl-datepicker.component';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
  imports: [CommonModule, PlIconModule, MomentDateModule, SharedModule, FormsModule, MatDatepickerModule],
  declarations: [PlDatepickerComponent],
  exports: [PlDatepickerComponent],
})
export class PlDatepickerModule {}
